import React, { useRef } from 'react';
import { ArticleBody } from './ArticleBody';
import { CtaBox } from './CtaBox';
import { CommentsSection } from './CommentsSection';
import { useVisitorLocation } from '../hooks/useVisitorLocation';
import { useReadingTime } from '../hooks/useReadingTime';
import { heroImage } from '../data/sectionImages';
export function Article() {
  const {
    date,
    city,
    countryCode,
    resolved
  } = useVisitorLocation();
  const contentRef = useRef<HTMLDivElement>(null);
  const readingMinutes = useReadingTime(contentRef);
  const bylinePlace = city ?? (resolved ? 'Mi Cocina Natural' : '');
  return <article className="mx-auto max-w-article px-4 pb-14 pt-8 sm:px-6 sm:pt-12" data-id="element-7" data-mp="pnlk9os6oba8">
      <p className="font-sans text-[0.72rem] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-8" data-mp="knzc3tr7pl8a">
        Nutrición digestiva / Mujeres +35
      </p>

      <div ref={contentRef} data-id="element-9" data-mp="zm1bdrr7nkjq">
        <h1 className="mt-3 font-serif text-[2rem] font-bold leading-[1.15] tracking-tight text-ink sm:text-[2.6rem]" data-id="element-10" data-mp="zj5co17jgru8">
          La razón por la que muchas mujeres se inflaman aunque «coman sano» cada noche
        </h1>

        <p className="mt-2 font-sans text-[0.8rem] text-ink-soft" data-id="element-11" data-mp="1m9sdajdz4bqd">📅 Publicado el: {date}</p>

        <h2 className="mt-5 font-serif text-[1.15rem] font-normal italic leading-relaxed text-ink-soft sm:text-[1.3rem]" data-id="element-12" data-mp="1qbndfkk64j2k">
          El problema podría no estar solo en lo que comes, sino en lo que tu cuerpo logra digerir
          cuando llega la noche.
        </h2>

        <div className="mt-6 flex flex-wrap items-center gap-x-3 gap-y-1 border-y border-brand-blush py-3 font-sans text-[0.78rem] text-ink-muted" data-id="element-13" data-mp="209l0w5u7ebu4">
          <span className="flex items-center gap-1.5 font-semibold text-ink" data-id="element-14" data-mp="29z4lbfxkedr3">
            Por: Redacción {bylinePlace}
            {city && countryCode && <img src={`https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`} alt={`Bandera ${countryCode}`} className="h-3 w-[18px] rounded-[2px] object-cover shadow-[0_0_0_1px_rgba(0,0,0,0.08)]" data-id="element-15" data-mp="2e3c8h8odjln7" />}
          </span>
          <span aria-hidden="true" data-id="element-16" data-mp="nv3dcemiw2q6">|</span>
          <span data-id="element-17" data-mp="iyl9ri2xiaff">Actualizado hoy</span>
          <span aria-hidden="true" data-id="element-18" data-mp="izo27ufwgkxg">|</span>
          <span data-id="element-19" data-mp="xmpk9yrtvfn4">{readingMinutes} min de lectura</span>
        </div>

        <figure className="mt-7" data-id="element-20" data-mp="xoaipzh9jiq9">
          <img src={heroImage.src} alt={heroImage.alt} className="aspect-[16/9] w-full rounded-sm bg-brand-blush object-cover" data-id="element-21" data-mp="swiwu291y16g" />
          <figcaption className="mt-2 font-sans text-xs leading-relaxed text-ink-muted" data-id="element-22" data-mp="16pidi7kkm1fl">
            {heroImage.caption}
          </figcaption>
        </figure>

        <ArticleBody data-id="element-23" data-mp="1gkip56m0hzn5" />
      </div>

      <CtaBox data-id="element-24" data-mp="1gjr06emx705u" />

      <CommentsSection data-id="element-25" data-mp="1bmqva71t43gb" />
    </article>;
}